import React, { Component } from 'react';
import { Col, Row, Alert } from 'react-bootstrap/lib';
import { DateInput, LoadingScreen, MultiDropDown, VehSingleDropDown } from '../../generic/input';
import { MENUPATH } from "../../lib/enums";
import { NOTIFICATION_TYPE, NOTIF_CNT, TODAY_START_TS, NOTIF_TYPE } from '../../lib/enums';
import { ShowErrorMsg } from '../../generic/genericFunctions';
import { isVehValid } from '../../lib/common';
import { timeFormat, StampTODate } from '../../lib/dtconv';
import { getNotifFromDb, getLatestEventsWTS, GetTodaysTlFromDb } from '../../db/timelineEvents';
import bgImage from "../../images/notiWait.png";

export default class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifs: [],
      errMsg: "",
      isLoading: false,
      notifFltrOpts: [],
      vehFltrTitle: "Vehicle filter",
      nfTypes: [],
      disPrevBtn: false,
      infoMsg: "",
      loadMore: false
    }
    this.filters = {};
    global.EE.addEventListener(global.EE.EVENT_TYPES.EVENTS_SAVED_IN_DB, this.handleNotifs);
    global.EE.addEventListener(global.EE.EVENT_TYPES.NEW_NOTIF, this.onLatestNotif);
  }

  componentDidMount() {
    if (global.wsOnline && global.bikeDetails) this.onVehicles(global.bikeDetails);
    global.EE.emitEvent(global.EE.EVENT_TYPES.MENU_CHANGE, MENUPATH.NOTIFICATIONS);
  }

  componentWillUnmount() {
    global.EE.removeEventListener(global.EE.EVENT_TYPES.EVENTS_SAVED_IN_DB, this.handleNotifs);
    global.EE.removeEventListener(global.EE.EVENT_TYPES.NEW_NOTIF, this.onLatestNotif);
  }

  onVehicles = (vehicles) => {
    this.vehicles = vehicles;
    var loc = this.props.location;
    if ((loc.query && loc.query.veh && !Array.isArray(loc.query.veh)) || (this.vehicles.length === 1)) {
      if (this.vehicles.length === 1) this.selVid = this.vehicles[0].idx;
      else this.selVid = +loc.query.veh;
      if (this.vehicles && this.selVid) this.validVeh = isVehValid(this.vehicles, [this.selVid]);
      if (this.validVeh) {
        var newUrl = loc.pathname + "?veh=" + this.selVid;
        this.props.router.replace(newUrl);
        var selVeh = this.vehicles.find(v => v.idx === this.selVid);
        this.setState({
          vehFltrTitle: ((selVeh.vmk || "") + "  " + (selVeh.mo || "") + "  " + (selVeh.reg || selVeh.treg)),
          isLoading: true
        }, () => {
          this._getLatestNotif();
        });
      } else {
        this.setState({
          errMsg: "Please select valid vehicle to see notifications"
        });
      }
    } else {
      this.setState({ errMsg: "Please select the vehicle to get notifications" })
    }
  }

  onLatestNotif = (notif) => {
    var loc = this.props.location;
    if (loc && loc.query && loc.query.veh && notif.vid === parseInt(loc.query.veh, 10)) {
      this.newNotif = true;
      this._getLatestNotif();
    }
  }

  _getLatestNotif() {
    /**
     *  Get latest events for selected vehicle
     */
    getLatestEventsWTS(this.selVid, (err, wts) => {
      if (err) {
        console.error("IndexedDB error " + err);
      } else {
        var req = { a: "getTimelineEvents", d: { veh: [{ vid: this.selVid, wts: wts || Math.round(TODAY_START_TS / 1000) }] } }; // wts not present then request today's tlevents
        this.latestEvents = true;
        global.gWebSocket.SendRequest({ data: req });
      }
    });
  }

  _getTodaysTlFromDb = () => {
    GetTodaysTlFromDb([this.selVid])
      .then((todaysEvts) => {
        if (!todaysEvts || !todaysEvts.length) this._getNotifs({ count: NOTIF_CNT }); //If todays events are not present then request for latest events by limit
        else this.showNotifications(todaysEvts);
      }).catch(e => {
        console.error(e);
        this.setState({
          errMsg: "Error while fetching todays notifications",
          isLoading: false
        });
      });
  }

  _getNotifs = (filter) => {
    let params = { vids: [this.selVid] };
    if (filter && filter.lastTs) params.toTs = filter.lastTs;
    if (filter.count) params.count = filter.count;

    getNotifFromDb(params, (err, notifs) => {
      if (err) {
        this.setState({
          errMsg: "Server unavailable please try again later",
          isLoading: false
        });
      }
      else {
        if (notifs && notifs.length) {
          let notifsLen = notifs.length;
          if (this.state.loadMore) {
            if (notifsLen < NOTIF_CNT) { // if already presented notifications are less than NOTIF_CNT
              let allNotifs = this.allNotifs;
              global.EE.emitEvent(global.EE.EVENT_TYPES.GET_EVENTS_BY_LIMIT, { vid: this.selVid, limit: (NOTIF_CNT - notifsLen) });
              allNotifs.push.apply(allNotifs, notifs);
            } else {
              notifs.push.apply(notifs, this.allNotifs);
              this.showNotifications(notifs);
            }
          } else this.showNotifications(notifs);
        } else global.EE.emitEvent(global.EE.EVENT_TYPES.GET_EVENTS_BY_LIMIT, { vid: this.selVid });
      }
    });
  }

  handleNotifs = (notifs) => {
    if (this.latestEvents) {
      this.latestEvents = false;
      if (this.newNotif) {
        this.newNotif = false;
        if (!this.state.nfTypes.length && !this.state.toTs) // If not any notification type and date filter is applied then show todays notifications.
          this._getTodaysTlFromDb();
      } else this._getTodaysTlFromDb();
    }
    else {
      if (notifs.tlEvents) {
        if (!notifs.tlEvents.length) {
          let stateObj = { isLoading: false };
          if (this.state.loadMore) stateObj.infoMsg = "No more previous notifications are availble for this vehicle";
          else stateObj.errMsg = "Notifications are not available for this vehicle";
          this.setState(stateObj);
        } else {
          if (notifs.processedEvts && notifs.processedEvts.length) {
            if (this.state.loadMore && this.allNotifs.length) {
              notifs.processedEvts.push.apply(notifs.processedEvts, this.allNotifs);
            }
            this.showNotifications(notifs.processedEvts);
          } else {
            this.setState({
              isLoading: false
            });
          }
        }
      } else {
        this.setState({
          isLoading: false
        });
      }
    }
  }

  showNotifications = (nfs) => {
    if (nfs && nfs.length) {
      var uniqueNfTypes = new Set(), nfTypesArr, notifTypes;
      nfs.forEach((nf) => {
        if (!uniqueNfTypes.has(nf.t)) uniqueNfTypes.add(nf.t);
      });

      nfTypesArr = [...uniqueNfTypes];

      notifTypes = NOTIFICATION_TYPE.filter((nf) => {
        return nfTypesArr.includes(nf.t)
      });

      nfs = nfs.sort((a, b) => a.ts - b.ts);

      nfs = this.checkTruthMatrix(nfs);

      this.allNotifs = JSON.parse(JSON.stringify(nfs));  //copy array of objects

      this.setState({
        notifs: nfs,
        minDt: null,
        maxDt: null,
        isLoading: false,
        notifFltrOpts: []
      }, () => {
        /**
         * Need to unmount and mount again the date component so that month names can be visible for new date range
         * Same as for notification type filter so that new noti types can be visible.
         */
        this.setState({
          minDt: (this.allNotifs[0].ts * 1000),
          maxDt: new Date(this.allNotifs[this.allNotifs.length - 1].ts * 1000).setHours(23, 59, 59, 999),
          notifFltrOpts: notifTypes
        });
        if (this.state.nfTypes.length || (this.state.fromTs && this.state.toTs)) {
          this.applyFiltersOnNotif();
        }
      });
    } else {
      this.setState({
        errMsg: "Notifications are not available for this vehicle",
        notifs: [],
        notifFltrOpts: []
      });
    }
  }

  loadPrev = () => {
    if (this.allNotifs.length) {
      let lastTs = (this.allNotifs[0].ts - 1);
      this.setState({
        loadMore: true,
        isLoading: true
      }, () => {
        this._getNotifs({ lastTs, count: NOTIF_CNT });
      });
    }
  }

  applyFiltersOnNotif = () => {
    let notifs = JSON.parse(JSON.stringify(this.allNotifs));
    if (this.state.fromTs && this.state.toTs && !this.state.nfTypes.length) {
      notifs = notifs.filter((nf) => {
        return ((nf.ts * 1000) >= this.state.fromTs && (nf.ts * 1000) <= this.state.toTs);
      });
    } else if (this.state.fromTs && this.state.toTs && this.state.nfTypes.length) {
      notifs = notifs.filter((nf) => {
        return (this.state.nfTypes.includes(nf.t) && ((nf.ts * 1000) >= this.state.fromTs && (nf.ts * 1000) <= this.state.toTs));
      });
    } else if (!this.state.fromTs && !this.state.toTs && this.state.nfTypes.length) {
      notifs = notifs.filter((nf) => {
        return this.state.nfTypes.includes(nf.t);
      });
    }

    let errMsg;
    if (!notifs.length) {
      errMsg = "Notifications are not present"
    }
    this.setState({
      notifs,
      isLoading: false,
      errMsg
    });
  }

  checkTruthMatrix = (notifs) => {
    if (notifs && notifs.length) {
      notifs = notifs.filter((nf, i) => {
        return ((i === 0) || (global.listeners.checkMatrix(notifs[i - 1].t, notifs[i].t)))
      });
      return notifs;
    }
  }

  handleNotifFilter = (e) => {
    this.setState({
      isLoading: true,
      nfTypes: e || []
    }, () => {
      this.applyFiltersOnNotif();
    });
  }

  dateChange = (e) => {
    if (e.length > 1) {
      this.setState({
        fromTs: e[0].getTime(),
        toTs: e[1].setHours(23, 59, 59, 999),
        isLoading: true
      }, () => {
        this.applyFiltersOnNotif();
      });
    }
  }

  onVehSelect = (veh) => {
    let newTitle = (veh.vmk || "") + "  " + (veh.mo || "") + "  " + (veh.reg || veh.treg);
    this.selVid = veh.idx;
    // this.validVeh = isVehValid(this.vehicles, vids);  TODO check query parameter vehicle is valid or not
    var newUrl = this.props.location.pathname + "?veh=" + veh.idx;
    this.props.router.replace(newUrl);
    this.setState({
      vehFltrTitle: newTitle,
      infoMsg: "",
      loadMore: false,
      notifs: [],
      fromTs: null,
      toTs: null,
      nfTypes: [],
      isLoading: true
    });
    this._getLatestNotif();
  }

  render() {
    return (
      <Col>
        {this.state.isLoading ? <LoadingScreen /> : null}
        <Row style={{ marginBottom: "10px" }}>
          <Col lg={4} lgOffset={8} md={6} mdOffset={6} sm={6} smOffset={6} xs={12}>
            {
              this.vehicles && this.vehicles.length > 1 ?
                <VehSingleDropDown
                  vehicles={this.vehicles}
                  onClick={(e) => this.onVehSelect(e)}
                  title={this.state.vehFltrTitle} />
                : null
            }
          </Col>
        </Row>
        <Col lg={12} md={12} sm={12} xs={12} className={"height-75vh"} style={{ border: "1px solid #ccc", paddingTop: "15px", paddingBottom: "15px" }}>
          {
            this.allNotifs && this.allNotifs.length ?
              <Col>
                <Row>
                  {
                    this.state.notifFltrOpts && this.state.notifFltrOpts.length ?
                      <Col lg={6} md={6} sm={6} xs={12} style={{ marginBottom: "2%" }}>
                        <MultiDropDown id="notif" labelName="Notification Filter" multiple={true} options={this.state.notifFltrOpts}
                          defaultOption="Select Notification Type" value={this.state.nfTypes} unique="t" name="nm" search="true" onChange={(e) => { this.handleNotifFilter(e) }} />
                      </Col>
                      : null
                  }
                  {
                    this.state.minDt && this.state.maxDt ?
                      <Col lg={4} md={6} sm={6} xs={12} style={{ marginBottom: "3%" }}>
                        <DateInput height="40px" mode={true} placeholder="Select Date Range" defaultdate={[this.state.fromTs, this.state.toTs]} mindate={this.state.minDt} maxdate={this.state.maxDt} onChange={(e) => this.dateChange(e)}></DateInput>
                      </Col>
                      : null
                  }
                </Row>
                {
                  this.state.notifs.length ?
                    <Row style={{ height: "60vh" }} >
                      <Col className="notif" >
                        <Col className="left-timeline" />
                        {
                          this.state.notifs
                            .sort((a, b) => { return b.ts - a.ts })
                            .map((nf, i) => {
                              let notifObj = nf.t ? NOTIFICATION_TYPE.find((n) => n.t === nf.t) : null;
                              return (
                                <Col key={i} className={notifObj.dotStyle + " col-lg-12 col-md-12 col-sm-12 col-xs-12"} style={{ paddingTop: i === 0 ? "0px" : "25px" }}>
                                  <Col style={{ marginTop: "-17px" }} >
                                    <span className="col-lg-3  col-md-3 col-sm-3 col-xs-4 font-size14px"><b>{nf.ts ? timeFormat(nf.ts * 1000, true) : ""}</b></span>
                                    <span className="col-lg-3 col-md-3 col-sm-3 col-xs-4 font-size14px color-9b9b9b" style={{ paddingLeft: "15px" }}>{nf.ts ? StampTODate(nf.ts * 1000) : ""}</span>
                                    <span className="col-lg-3 col-md-6 col-sm-6 col-xs-4 font-size14px" style={{ paddingLeft: "15px" }}>
                                      {notifObj ?
                                        notifObj.nm +
                                          (notifObj.t === NOTIF_TYPE.SPEED_ALERT && nf.meta ?
                                          " ( " + nf.meta.spd + " km/h ) "
                                          : notifObj.t === NOTIF_TYPE.GEO_FENCE ? " ( " + (nf.meta.igf ? "Entered" : "Exited") + " )" : "") : ""
                                      }</span>
                                  </Col>
                                </Col>
                              )
                            })
                        }
                      </Col>
                    </Row>
                    :
                    this.state.errMsg ? <Alert bsStyle='warning'>{this.state.errMsg}</Alert> : null
                }
              </Col>
              :
              this.state.errMsg ? ShowErrorMsg(this.state.errMsg, bgImage) : null
          }
        </Col>
        {
          this.selVid && this.state.notifs.length ?
            <Col lg={12} md={12} sm={12} xs={12} style={{ paddingTop: "1%", paddingLeft: "0px" }}>
              {
                this.state.infoMsg ?
                  <Alert bsStyle="info"> {this.state.infoMsg}</Alert>
                  :
                  <Col lg={3} md={4} sm={4} xs={9} style={{ paddingTop: "2%", paddingLeft: "0px" }}>
                    <button className="form-control btn-info col-lg-3 col-md-4 col-sm-4 col-xs-6" style={{}} onClick={() => this.loadPrev()} disabled={this.state.disPrevBtn}>&laquo; Load Previous</button>
                  </Col>
              }
            </Col>
            : null
        }

      </Col>
    )
  }
}